<form class="vtr-ui-custom-slider">
	<div class="range">
		<output class="bubble"
			*ngIf="showTip"
			#sliderBubble
			[style.visibility]="isTooltipHidden?'hidden':'visible'"
			[for]="sliderId+'-slider'">
			{{tipValue}}
		</output>
		<input type="range"
			#rangeSlider
			[style]="'opacity:' + sliderOpacity"
			role="slider"
			[disabled]="isDisabled"
			[name]="sliderId+'-slider'"
			[id]="sliderId+'-slider'"
			[attr.aria-valuemin]="min"
			[attr.aria-valuemax]="max"
			[attr.aria-valuenow]="value"
			[attr.aria-label]="ariaLabel"
			[attr.aria-valuetext]="showTip && tipSuffix? value+tipSuffix:getLegend()"
			[attr.aria-orientation]="'horizontal'"
			[step]="step"
			[min]="min"
			[max]="max"
			[value]="value"
			(mousedown)="onMouseDown($event)"
			(mouseup)="onDragEnd($event)"
			(focus)="onDragStart($event)"
			(blur)="onDragEnd($event)"
			(input)="onInputChange($event)"
		>
		<div class="d-flex justify-content-between legends pl-2"
			[class.legends-disabled]="isDisabled">
			<span *ngIf="minLegend?.length>0"
				id='min-legend-{{sliderId}}'
				[attr.aria-label]="minLegend">
				{{ minLegend }}
			</span>
			<span *ngIf="midLegend?.length>0"
				id='mid-legend-{{sliderId}}'
				[attr.aria-label]="midLegend">
				{{ midLegend }}
			</span>
			<div *ngIf="maxLegend?.length>0"
				id='max-legend-{{sliderId}}'
				[attr.aria-label]="maxLegend">
				{{ maxLegend }}
			</div>
		</div>
	</div>
</form>
